var View = require('views/base/view');
var CourseSettingsService = require('services/course-settings-service');
var SurveyService = require('services/survey-service');
var ProgressService = require('services/progress-service');

var SurveyView = View.extend({
  autoRender: true,
  autoAttach: true,
  template: require('./templates/survey'),
  className: 'panel panel-default',
  listen: {
    addedToDOM: 'loaded'
  },
  loaded: function() {
    var self = this;
    this.delegate('click', '.btn-survey.btn-danger', function(e){
      var button = e.currentTarget;
      var surveySlug = button.attributes['data-survey'].value;
      ProgressService.removeLocalActivityProgress(surveySlug)
        .done(() => self.render());
    });
    this.delegate('click', '.btn-survey.btn-success', function(e){
      var button = e.currentTarget;
      ProgressService.saveLocalActivityProgress({
        "attempt": 1,
        "enrollment_id": EF.enrollment.get('id'),
        "grade": null,
        "passed": true,
        "slug": button.attributes['data-survey'].value
      }).done(() => self.render());
    });
  },
  getTemplateData: function(){
    var model = {
      surveys: []
    };

    if (CourseSettingsService.get('surveys')) {
      CourseSettingsService.get('surveys').forEach((survey) => {
        model.surveys.push({
          slug: survey,
          progress: SurveyService.getActivityProgressForSlug(survey)
        });
      });
    }
    return model;
  }
});

export default SurveyView;